import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://latweangokzgkggcltgu.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxhdHdlYW5nb2t6Z2tnZ2NsdGd1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIzNTY5MjMsImV4cCI6MjA5NzkzMjkyM30.uSM77vsit-KxaA9VeHcw-SGbK49GzH7bmTw3exXGOls'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})